import { useState, useCallback } from "react"

export type LegendEntry = {
  value: string
  color: string
  dataKey: string
}

export const useLegendHover = () => {
  const [hoveredEntry, setHoveredEntry] = useState<LegendEntry | null>(null)

  const handleLegendHover = useCallback((entry: LegendEntry | null) => {
    setHoveredEntry(entry)
  }, [])

  const isHovered = useCallback(
    (dataKey: string) => hoveredEntry?.dataKey === dataKey,
    [hoveredEntry],
  )

  const getOpacity = useCallback(
    (dataKey: string) => (hoveredEntry ? (isHovered(dataKey) ? 1 : 0.5) : 1),
    [hoveredEntry, isHovered],
  )

  const shouldShowDots = useCallback(
    (dataKey: string) => !hoveredEntry || isHovered(dataKey),
    [hoveredEntry, isHovered],
  )

  return {
    hoveredEntry,
    handleLegendHover,
    getOpacity,
    shouldShowDots,
  }
}
